import React, { useEffect, useState } from 'react'
import classes from "./CreatePrediction.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { editUserPredictionsApi, fetchUpcomingMatchDetailsApi, getUserPredictionsApi, saveUserPredictionsApi } from '../http/http';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import { FaArrowLeft, FaMinus } from 'react-icons/fa6';
import { Dropdown } from "primereact/dropdown";
import Container from '../component/Container';
import { toast } from 'react-toastify';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { useTranslation } from 'react-i18next';

const CreatePrediction = () => {

    const location = useLocation();
    const [matchDetails, setMatchDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(true);
    const navigate = useNavigate();
    const { userDetails } = useSelector((state) => state.persisted.userSlice);
    const [players, setPlayers] = useState(null);
    const [time, setTime] = useState(null);
    const [attackers, setAttackers] = useState([]);
    const [defenders, setDefenders] = useState([]);
    const [midfielders, setMidfielders] = useState([]);
    const [goalkeeper, setGoalkeeper] = useState([]);
    const [homeTeamLineups, setHomeTeamLineups] = useState([]);
    const [awayTeamLineups, setAwayTeamLineups] = useState([]);
    const [allPlayers, setAllPlayers] = useState([]);
    const [questions, setQuestions] = useState([]);

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const { t } = useTranslation();

    const [predictionLoading, setPredictionLoading] = useState(false);

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [selectedOption2, setSelectedOption2] = useState(null);
    const [selectedOption3, setSelectedOption3] = useState(null);
    const [selectedOption4, setSelectedOption4] = useState(null);
    const [selectedOption5, setSelectedOption5] = useState(null);
    const [selectedOption6, setSelectedOption6] = useState(null);
    const [selectedOption7, setSelectedOption7] = useState(null);
    const [selectedOption8, setSelectedOption8] = useState(null);

    const [selectedOption_4, setSelectedOption_4] = useState({});
    const [selectedOption_7, setSelectedOption_7] = useState({});
    const [selectedOption_8, setSelectedOption_8] = useState({});

    const dispatch = useDispatch();

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));

            if (timeLeft.asMilliseconds() <= 0) {
                console.log("Match has already started.");
                navigate("/home");
                toast.info(t("161"));
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();

            console.log(`Match starts in ${hours}h ${minutes}m ${seconds}s`);
            // return `${hours}h ${minutes}m ${seconds}s`;
            setTime(`${hours}h ${minutes}m ${seconds}s`)
            // setExpireTime(`${hours}h ${minutes}m ${seconds}s`)
        } catch (error) {
            console.log(error, 'errro--');
        }
    }

    useEffect(() => {
        if (matchDetails) {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);

            return () => {
                clearInterval(intervalId);
            }
        }
    }, [matchDetails]);

    const fetchMatchDetails = async (match_fixture_id, load) => {
        try {
            if (load) {
                setLoading(true);
            }
            setLoader(true);
            const response = await fetchUpcomingMatchDetailsApi(match_fixture_id, userDetails?.token);
            console.log(response, 'match details response');
            setMatchDetails(response?.data);
            setPlayers(() => {
                return {
                    homeTeam: JSON.parse(response?.data?.home_team_players),
                    awayTeam: JSON.parse(response?.data?.away_team_players)
                }
            });
            setQuestions(JSON.parse(response?.data?.prediction_questions));
            setLoading(false);
            setLoader(false);

        }
        catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                setLoader(false);
                setLoading(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
                console.log(error, 'error---');
            }
        }
    }

    const fetchUserPredictions = async () => {
        try {
            setLoading(true);
            const response = await getUserPredictionsApi(location?.state?.match_fixture_id, userDetails?.token);
            const userPredictions = JSON.parse(response?.data?.[0]?.predictions);
            userPredictions.forEach((prediction, index) => {
                const predictionKey = Object.keys(prediction)[0];
                switch (predictionKey) {
                    case "prediction1":
                        setSelectedOption1(prediction[predictionKey]);
                        break;
                    case "prediction2":
                        setSelectedOption2(prediction[predictionKey]);
                        break;
                    case "prediction3":
                        setSelectedOption3(prediction[predictionKey]);
                        break;
                    case "prediction4":
                        setSelectedOption4(prediction[predictionKey][0]);
                        setSelectedOption_4(prediction[predictionKey][1]);
                        break;
                    case "prediction5":
                        setSelectedOption5(prediction[predictionKey]);
                        break;
                    case "prediction6":
                        setSelectedOption6(prediction[predictionKey]);
                        break;
                    case "prediction7":
                        setSelectedOption7(prediction[predictionKey][0]);
                        setSelectedOption_7(prediction[predictionKey][1]);
                        break;
                    case "prediction8":
                        setSelectedOption8(prediction[predictionKey][0]);
                        setSelectedOption_8(prediction[predictionKey][1]);
                        break;
                    default:
                        break;
                }
            });

            setLoading(false);

        } catch (error) {
            setLoading(false);

            console.log(error, 'error---');
        }
    }

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(location?.state?.match_fixture_id, true);

            if (location?.state?.edit) {
                // fetch user predictions...
                fetchUserPredictions();
            }
        }
        else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails(location?.state?.match_fixture_id, false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader, location?.state?.match_fixture_id]);


    console.log(matchDetails, 'match details...');

    useEffect(() => {
        const home = players?.homeTeam || {};
        const away = players?.awayTeam || {};

        setAttackers([
            ...(home.attackers || []),
            ...(away.attackers || [])
        ]);

        setDefenders([
            ...(home.defenders || []),
            ...(away.defenders || [])
        ]);

        setMidfielders([
            ...(home.midfielders || []),
            ...(away.midfielders || [])
        ]);

        setGoalkeeper([
            ...(home.goalkeepers || []),
            ...(away.goalkeepers || [])
        ]);

        setAllPlayers([
            ...(home.attackers || []),
            ...(home.defenders || []),
            ...(home.midfielders || []),
            ...(home.goalkeepers || []),
            ...(away.attackers || []),
            ...(away.defenders || []),
            ...(away.midfielders || []),
            ...(away.goalkeepers || [])
        ]);
    }, [players]);

    const savePredictionHandler = async () => {
        try {

            setPredictionLoading(true);
            const predictions = [
                selectedOption1 && { prediction1: selectedOption1 },
                selectedOption2 && { prediction2: selectedOption2 },
                selectedOption3 && { prediction3: selectedOption3 },
                selectedOption4 && { prediction4: [selectedOption4, selectedOption_4] },
                selectedOption5 && { prediction5: selectedOption5 },
                selectedOption6 && { prediction6: selectedOption6 },
                selectedOption7 && { prediction7: [selectedOption7, selectedOption_7] },
                selectedOption8 && { prediction8: [selectedOption8, selectedOption_8] },
            ];

            if (location?.state?.edit) {
                const response = await editUserPredictionsApi(matchDetails?.match_fixture_id, predictions,
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city, matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image, matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image, matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image, userDetails?.token);

                console.log(response, 'response....');
            }
            else {
                const response = await saveUserPredictionsApi(matchDetails?.match_fixture_id, predictions,
                    matchDetails?.match_date_time,
                    matchDetails?.match_venue_name, matchDetails?.match_venue_city, matchDetails?.league_id, matchDetails?.league_name, matchDetails?.league_image, matchDetails?.home_team_id, matchDetails?.home_team_name, matchDetails?.home_team_image, matchDetails?.away_team_id, matchDetails?.away_team_name, matchDetails?.away_team_image, userDetails?.token);

                console.log(response, 'response....');
            }


            setPredictionLoading(false);

            navigate("/prediction-game", {
                state: {
                    match_fixture_id: matchDetails?.match_fixture_id
                }
            })

        } catch (error) {
            console.log(error, 'error---');
            setPredictionLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
                console.log(error, 'error---');
            }

        }
    };


    const itemTemplate = (option) => {
        return (
            <div className={classes.selector}>
                <span>{option.answer}</span>
                {option.playing && (
                    <span className={classes.highlight}>
                        <i
                            className={`fa fa-circle ${classes.text_danger_glow} ${classes.blink}`}
                            style={{ fontSize: "10px" }}
                        ></i>
                        {t("162")}
                    </span>
                )}
            </div>
        );
    };


    return (
        <>
            <Layout>
                <SubLayout>

                    {loading ? <SmallLoader style={{ minHeight: "80dvh", display: "flex", justifyContent: "center", alignItems: "center" }} /> : (
                        <>
                            <div className={classes.header}>
                                <div className={classes.header_nav}>
                                    <div className={classes.header_nav_container}>
                                        <button type='button' className={classes.back_button}>
                                            <FaArrowLeft className={classes.back_icon} onClick={() => navigate("/home")} />
                                        </button>
                                        <div className={classes.header_text_container}>
                                            <p className={classes.header_text}>{t("160")}</p>
                                            <p className={classes.header_timer}>{time} {t("23")}</p>
                                        </div>

                                    </div>
                                    {/* <button type='button' className={classes.header_button}>
                                        {t("24")}
                                    </button> */}

                                </div>

                                <div className={classes.match_details_container}>
                                    <div className={classes.match_details}>
                                        <div className={classes.team}>
                                            <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                            <p className={classes.team_name}>{matchDetails?.home_team_name}</p>
                                        </div>
                                        <div className={classes.divider_container}>
                                            <FaMinus className={classes.divider} />
                                        </div>
                                        <div className={classes.team}>
                                            <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                            <p className={classes.team_name}>{matchDetails?.away_team_name}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className={classes.info}>
                            <p className={classes.info_text}>Make a team of 11 players</p>
                        </div> */}

                                <div className={classes.tab_info}>
                                    <p className={classes.tab_info_text}>
                                        {t("163")}
                                    </p>
                                </div>
                            </div>

                            <Container>

                                {questions?.length > 0 ? (
                                    questions.map((question) => {
                                        return (
                                            <div className={classes.question} key={question?.id}>
                                                <p className={classes.question_title}>
                                                    {selectedLanguage==0 ? question?.name : question?.name_sw}
                                                    {/* {question?.name} */}
                                                </p>
                                                {question.id == 1 ? (
                                                    <Dropdown
                                                        filter
                                                        value={selectedOption1}
                                                        onChange={(e) => setSelectedOption1(e.value)}
                                                        options={[
                                                            {
                                                                answer: matchDetails?.home_team_name,
                                                                questionId: 1,
                                                                question: question?.name,
                                                                question_sw:question?.name_sw,
                                                                point: 0,
                                                                message: "",
                                                                message_sw:""
                                                            },
                                                            {
                                                                answer: matchDetails?.away_team_name,
                                                                questionId: 1,
                                                                question: question?.name,
                                                                question_sw:question?.name_sw,
                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: "Draw",
                                                                questionId: 1,
                                                                question: question?.name,
                                                                question_sw:question?.name_sw,
                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                        ]}
                                                        optionLabel="answer"
                                                        // virtualScrollerOptions={{ itemSize: 38 }}
                                                        placeholder={t("166")}
                                                        // className="w-full md:w-14rem"
                                                        id="dropdown_input"
                                                    />
                                                ) : question.id == 2 ? (
                                                    <Dropdown
                                                        filter
                                                        value={selectedOption2}
                                                        onChange={(e) => setSelectedOption2(e.value)}
                                                        options={[
                                                            {
                                                                answer: "0",
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,
                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 1,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 2,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 3,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 4,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 5,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 6,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 7,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 8,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 9,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 10,
                                                                questionId: 2,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                        ]}
                                                        optionLabel="answer"
                                                        // virtualScrollerOptions={{ itemSize: 38 }}
                                                        placeholder={t("167")}
                                                        className="w-full md:w-14rem"
                                                    />
                                                ) : question.id == 3 ? (
                                                    <Dropdown
                                                        filter
                                                        value={selectedOption3}
                                                        onChange={(e) => setSelectedOption3(e.value)}
                                                        options={[
                                                            {
                                                                answer: "0",
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 1,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 2,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 3,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 4,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 5,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 6,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 7,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 8,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 9,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                            {
                                                                answer: 10,
                                                                questionId: 3,
                                                                question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                point: 0,
                                                                message: "",
                                                                message_sw:""

                                                            },
                                                        ]}
                                                        optionLabel="answer"
                                                        // virtualScrollerOptions={{ itemSize: 38 }}
                                                        placeholder={t("167")}
                                                        className="w-full md:w-14rem"
                                                    />
                                                ) : question.id == 4 ? (
                                                    <>
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption4}
                                                            onChange={(e) => setSelectedOption4(e.value)}
                                                            options={[
                                                                {
                                                                    answer: "None",
                                                                    questionId: 4,
                                                                    point: 0,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    playerId: null,
                                                                    message: "",
                                                                    playing: false,
                                                                },
                                                                ...allPlayers.map((data) => {
                                                                    return {
                                                                        answer: data?.name,
                                                                        questionId: 4,
                                                                        point: 0,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        playerId: data?.id,
                                                                        message: "",
                                                                message_sw:"",

                                                                        playing:
                                                                            homeTeamLineups.length > 0 &&
                                                                                awayTeamLineups.length > 0
                                                                                ? homeTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                ) ||
                                                                                awayTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                )
                                                                                : false,
                                                                    };
                                                                }),
                                                            ]}
                                                            virtualScrollerOptions={{ itemSize: 38 }}
                                                            optionLabel="answer"
                                                            placeholder={t("168")}
                                                            className="w-full md:w-14rem"
                                                            itemTemplate={itemTemplate}
                                                        />
                                                        {selectedOption4?.answer != "None" && (
                                                            <Dropdown
                                                                filter
                                                                value={selectedOption_4}
                                                                onChange={(e) =>
                                                                    setSelectedOption_4(e.value)
                                                                }
                                                                options={[
                                                                    {
                                                                        answer: 1,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 2,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 3,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 4,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 5,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 6,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 7,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 8,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 9,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                    {
                                                                        answer: 10,
                                                                        questionId: 4,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        message: "",
                                                                message_sw:""

                                                                    },
                                                                ]}
                                                                optionLabel="answer"
                                                                // virtualScrollerOptions={{ itemSize: 38 }}
                                                                placeholder={t("167")}
                                                                className="w-full md:w-14rem"
                                                            />
                                                        )}
                                                    </>
                                                ) : question.id == 5 ? (
                                                    <>
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption5}
                                                            onChange={(e) => setSelectedOption5(e.value)}
                                                            options={[
                                                                {
                                                                    answer: "None",
                                                                    questionId: 5,
                                                                    point: 0,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    playerId: null,
                                                                    message: "",
                                                                message_sw:"",

                                                                    playing: false,
                                                                },
                                                                ...allPlayers.map((data) => {
                                                                    return {
                                                                        answer: data?.name,
                                                                        questionId: 5,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        playerId: data?.id,
                                                                        message: "",
                                                                message_sw:"",

                                                                        playing:
                                                                            homeTeamLineups.length > 0 &&
                                                                                awayTeamLineups.length > 0
                                                                                ? homeTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                ) ||
                                                                                awayTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                )
                                                                                : false,
                                                                    };
                                                                }),
                                                            ]}
                                                            virtualScrollerOptions={{ itemSize: 38 }}
                                                            optionLabel="answer"
                                                            placeholder={t("168")}
                                                            className="w-full md:w-14rem"
                                                            itemTemplate={itemTemplate}
                                                        />
                                                    </>
                                                ) : question.id == 6 ? (
                                                    <>
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption6}
                                                            onChange={(e) => setSelectedOption6(e.value)}
                                                            options={[
                                                                {
                                                                    answer: "None",
                                                                    questionId: 6,
                                                                    point: 0,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    playerId: null,
                                                                    message: "",
                                                                message_sw:"",
                                                                    playing: false,
                                                                },
                                                                ...allPlayers.map((data) => {
                                                                    return {
                                                                        answer: data?.name,
                                                                        questionId: 6,
                                                                        question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                        point: 0,
                                                                        playerId: data?.id,
                                                                        message: "",
                                                                message_sw:"",
                                                                        playing:
                                                                            homeTeamLineups.length > 0 &&
                                                                                awayTeamLineups.length > 0
                                                                                ? homeTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                ) ||
                                                                                awayTeamLineups[0]?.startXI?.find(
                                                                                    (dataPlayer) =>
                                                                                        dataPlayer?.player?.id ==
                                                                                        data?.id
                                                                                )
                                                                                : false,
                                                                    };
                                                                }),
                                                            ]}
                                                            virtualScrollerOptions={{ itemSize: 38 }}
                                                            optionLabel="answer"
                                                            placeholder={t("168")}
                                                            className="w-full md:w-14rem"
                                                            itemTemplate={itemTemplate}
                                                        />
                                                    </>
                                                ) : question.id == 7 ? (
                                                    <>
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption7}
                                                            onChange={(e) => setSelectedOption7(e.value)}
                                                            options={goalkeeper.map((data) => {
                                                                return {
                                                                    answer: data?.name,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    playerId: data?.id,
                                                                    message: "",
                                                                message_sw:"",
                                                                    playing:
                                                                        homeTeamLineups.length > 0 &&
                                                                            awayTeamLineups.length > 0
                                                                            ? homeTeamLineups[0]?.startXI?.find(
                                                                                (dataPlayer) =>
                                                                                    dataPlayer?.player?.id ==
                                                                                    data?.id
                                                                            ) ||
                                                                            awayTeamLineups[0]?.startXI?.find(
                                                                                (dataPlayer) =>
                                                                                    dataPlayer?.player?.id ==
                                                                                    data?.id
                                                                            )
                                                                            : false,
                                                                };
                                                            })}
                                                            virtualScrollerOptions={{ itemSize: 38 }}
                                                            optionLabel="answer"
                                                            placeholder={t("168")}
                                                            className="w-full md:w-14rem"
                                                            itemTemplate={itemTemplate}
                                                        />
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption_7}
                                                            onChange={(e) => setSelectedOption_7(e.value)}
                                                            options={[
                                                                {
                                                                    answer: 1,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 2,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 3,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 4,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 5,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 6,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 7,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 8,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 9,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 10,
                                                                    questionId: 7,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                            ]}
                                                            optionLabel="answer"
                                                            // virtualScrollerOptions={{ itemSize: 38 }}
                                                            placeholder={t("167")}
                                                            className="w-full md:w-14rem"
                                                        />
                                                    </>
                                                ) : question.id == 8 ? (
                                                    <>
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption8}
                                                            onChange={(e) => setSelectedOption8(e.value)}
                                                            options={goalkeeper.map((data) => {
                                                                return {
                                                                    answer: data?.name,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    playerId: data?.id,
                                                                    message: "",
                                                                message_sw:"",
                                                                    playing:
                                                                        homeTeamLineups.length > 0 &&
                                                                            awayTeamLineups.length > 0
                                                                            ? homeTeamLineups[0]?.startXI?.find(
                                                                                (dataPlayer) =>
                                                                                    dataPlayer?.player?.id ==
                                                                                    data?.id
                                                                            ) ||
                                                                            awayTeamLineups[0]?.startXI?.find(
                                                                                (dataPlayer) =>
                                                                                    dataPlayer?.player?.id ==
                                                                                    data?.id
                                                                            )
                                                                            : false,
                                                                };
                                                            })}
                                                            virtualScrollerOptions={{ itemSize: 38 }}
                                                            optionLabel="answer"
                                                            placeholder={t("168")}
                                                            className="w-full md:w-14rem"
                                                            itemTemplate={itemTemplate}
                                                        />
                                                        <Dropdown
                                                            filter
                                                            value={selectedOption_8}
                                                            onChange={(e) => setSelectedOption_8(e.value)}
                                                            options={[
                                                                {
                                                                    answer: 1,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 2,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:"",
                                                                },
                                                                {
                                                                    answer: 3,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""
                                                                },
                                                                {
                                                                    answer: 4,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 5,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 6,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 7,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 8,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 9,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                                {
                                                                    answer: 10,
                                                                    questionId: 8,
                                                                    question: question?.name,
                                                                question_sw: question?.name_sw,

                                                                    point: 0,
                                                                    message: "",
                                                                message_sw:""

                                                                },
                                                            ]}
                                                            optionLabel="answer"
                                                            // virtualScrollerOptions={{ itemSize: 38 }}
                                                            placeholder={t("167")}
                                                            className="w-full md:w-14rem"
                                                        />
                                                    </>
                                                ) : null}
                                            </div>
                                        );
                                    })
                                ) : (null)}


                                <button type='button' className={`${classes.next_button} ${(
                                    selectedOption1 && selectedOption2 && selectedOption3 && selectedOption4 && selectedOption5 && selectedOption6 && selectedOption7 && selectedOption8
                                ) && classes.active}`}
                                    disabled={(predictionLoading || !selectedOption1 || !selectedOption2 || !selectedOption3 || !selectedOption4 || !selectedOption5 || !selectedOption6 || !selectedOption7 || !selectedOption8)}
                                    onClick={() => {
                                        if (predictionLoading) {
                                            return;
                                        }
                                        if (selectedOption1 && selectedOption2 && selectedOption3 && selectedOption4 && selectedOption5 && selectedOption6 && selectedOption7 && selectedOption8) {
                                            savePredictionHandler();
                                        }
                                    }}
                                >
                                    {predictionLoading ? <SmallLoader /> : location?.state?.edit ? t("20") : t("53")}
                                </button>

                            </Container>

                        </>
                    )}


                </SubLayout>
            </Layout>
        </>
    )
}

export default CreatePrediction